var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReportShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6768 10.8705C6.6768 10.412 7.05189 10.0369 7.51034 10.0369H13.3451V5.59143H8.89956C8.28587 5.59143 7.78818 5.09374 7.78818 4.48005V0.0345459H1.67561C0.754904 0.0345459 0.00854492 0.780905 0.00854492 1.70161V16.1495C0.00854492 17.0699 0.754904 17.8166 1.67561 17.8166H11.678C12.5987 17.8166 13.3451 17.0702 13.3451 16.1495V11.704H7.51034C7.05189 11.704 6.6768 11.3324 6.6768 10.8705ZM8.89956 0.0345459V4.48005H13.3451L8.89956 0.0345459ZM19.7389 10.28L16.9605 7.50161C16.6349 7.17601 16.1075 7.17601 15.7818 7.50161C15.456 7.82721 15.4562 8.35459 15.7818 8.68036L17.1689 10.0369H13.3451V11.704H17.1689L15.8134 13.0595C15.6477 13.2217 15.5678 13.4336 15.5678 13.6489C15.5678 13.8642 15.6492 14.0754 15.812 14.2383C16.1376 14.5639 16.665 14.5639 16.9908 14.2383L19.7692 11.4598C20.0932 11.1344 20.0932 10.6065 19.7389 10.28Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportShare);
export default __webpack_public_path__ + "static/media/icon-report-share.99004dd102a90689e6b1863650b81b59.svg";
export { ForwardRef as ReactComponent };